import { render, staticRenderFns } from "./projectdetails.vue?vue&type=template&id=3ba3ebc6&scoped=true&"
import script from "./projectdetails.vue?vue&type=script&lang=js&"
export * from "./projectdetails.vue?vue&type=script&lang=js&"
import style0 from "./projectdetails.vue?vue&type=style&index=0&id=3ba3ebc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba3ebc6",
  null
  
)

export default component.exports